/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export function GoogleMeetIcon({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 87.50999999999999 72"
      width={width}
      height={height}
      className="icon-svg google-meet"
    >
      <path fill="#00832d" d="M49.5 36l8.53 9.75 11.47 7.33 2-17.02-2-16.64-11.69 6.44z" />
      <path fill="#0066da" d="M0 51.5V66c0 3.315 2.685 6 6 6h14.5l3-10.96-3-9.54-9.95-3z" />
      <path fill="#e94235" d="M20.5 0L0 20.5l10.55 3 9.95-3 2.95-9.41z" />
      <path fill="#2684fc" d="M20.5 20.5H0v31h20.5z" />
      <path
        fill="#00ac47"
        d="M82.6 8.68L69.5 19.42v33.66l13.16 10.79c1.97 1.54 4.85.135 4.85-2.37V11c0-2.535-2.945-3.925-4.91-2.32zM49.5 36v15.5h-29V72h43c3.315 0 6-2.685 6-6V53.08z"
      />
      <path fill="#ffba00" d="M63.5 0h-43v20.5h29V36l20-16.57V6c0-3.315-2.685-6-6-6z" />
    </svg>
  );
}

GoogleMeetIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export function CalendarIcon({ width, height }) {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" width={width} height={height}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
}

CalendarIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

CalendarIcon.defaultProps = {
  width: 20,
  height: 20,
};

export function DocuSyncIcon() {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2V8C12 9.10457 12.8954 10 14 10H20V20C20 21.1046 19.1046 22 18 22H11.1904C12.3112 20.8321 13 19.2465 13 17.5C13 13.9101 10.0899 11 6.5 11C5.6141 11 4.76959 11.1772 4 11.4982V4C4 2.89543 4.89543 2 6 2H12ZM13.5 2.5V8C13.5 8.27614 13.7239 8.5 14 8.5H19.5L13.5 2.5ZM1 17.5C1 20.5376 3.46243 23 6.5 23C9.53757 23 12 20.5376 12 17.5C12 14.4624 9.53757 12 6.5 12C3.46243 12 1 14.4624 1 17.5ZM9.5 14C9.77614 14 10 14.2239 10 14.5V16.5C10 16.7761 9.77614 17 9.5 17H7.5C7.22386 17 7 16.7761 7 16.5C7 16.2239 7.22386 16 7.5 16H8.50027C8.04362 15.392 7.31737 15 6.50002 15C5.66657 15 4.9283 15.4073 4.47325 16.036C4.31133 16.2597 3.99874 16.3098 3.77505 16.1478C3.55136 15.9859 3.50128 15.6733 3.6632 15.4496C4.29822 14.5724 5.33229 14 6.50002 14C7.47976 14 8.3651 14.4027 9 15.0506V14.5C9 14.2239 9.22386 14 9.5 14ZM4 19.9494V20.5C4 20.7761 3.77614 21 3.5 21C3.22386 21 3 20.7761 3 20.5V18.5C3 18.2239 3.22386 18 3.5 18H5.5C5.77614 18 6 18.2239 6 18.5C6 18.7761 5.77614 19 5.5 19H4.49976C4.95641 19.608 5.68266 20 6.50002 20C7.26635 20 7.95179 19.6558 8.41116 19.1118C8.58932 18.9008 8.90478 18.8742 9.11576 19.0523C9.32675 19.2305 9.35336 19.546 9.17521 19.7569C8.53396 20.5164 7.57322 21 6.50002 21C5.52026 21 4.6349 20.5973 4 19.9494Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DropdownIcon() {
  return (
    <svg
      viewBox="0 0 20 20"
      height="20"
      width="20"
      preserveAspectRatio="xMidYMid meet"
      className=""
      fill="none"
    >
      <title>ic-chevron-down-menu</title>
      <path
        d="M9.99971 12.1L14.8997 7.2C15.083 7.01667 15.3164 6.925 15.5997 6.925C15.883 6.925 16.1164 7.01667 16.2997 7.2C16.483 7.38333 16.5747 7.61667 16.5747 7.9C16.5747 8.18333 16.483 8.41667 16.2997 8.6L10.6997 14.2C10.4997 14.4 10.2664 14.5 9.99971 14.5C9.73304 14.5 9.49971 14.4 9.29971 14.2L3.69971 8.6C3.51637 8.41667 3.42471 8.18333 3.42471 7.9C3.42471 7.61667 3.51637 7.38333 3.69971 7.2C3.88304 7.01667 4.11637 6.925 4.39971 6.925C4.68304 6.925 4.91637 7.01667 5.09971 7.2L9.99971 12.1Z"
        fill="rgba(0,0,0,.6)"
      />
    </svg>
  );
}
